import { Box, TableCell, TableRow, Typography, useTheme } from "@mui/material";

import { tk } from "@thalamos/vision-common";

import { Translation } from "../../../Translation/Translation.js";

export function PendingTransferBannerRow({ colSpan }: { colSpan: number }) {
  const theme = useTheme();

  return (
    <TableRow className="structural-row">
      <TableCell colSpan={colSpan}>
        <Box
          sx={{
            display: "flex",
            width: "auto",
            justifyContent: "center",
            backgroundColor: theme.palette.warning.main,
            borderColor: theme.palette.warning.main,
            borderWidth: 1,
            borderStyle: "solid",
          }}
        >
          <Typography
            variant="body1"
            color={theme.palette.text.primary}
            px={5}
            sx={{ fontWeight: "bold" }}
          >
            <Translation
              translationKey={tk("incidentWorkItem.pendingTransfer")}
            />
          </Typography>
        </Box>
      </TableCell>
    </TableRow>
  );
}
